import { Form, Input } from 'antd'

import { TaskFormElement } from './types'

type Props = {
  element: TaskFormElement
  required?: boolean
}

export const NumberElement = ({ element, required }: Props) => {
  return (
    <Form.Item name={element.name} label={element.label} rules={[{ required }]}>
      <Input type="number" />
    </Form.Item>
  )
}
